export interface UpdateStatusDto {
  isActive: boolean;
  reason?: string | null;
  effectiveDate?: string | null; // DateTime as ISO string
}
